module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('display', [_c('path-line', {
    attrs: {
      "file-name": "layers"
    },
    slot: "path"
  }), _vm._v(" "), _c('template', {
    slot: "sections"
  }, [_c('display-section', {
    attrs: {
      "title": "layers"
    }
  }, [_c('p', {
    slot: "description"
  }, [_vm._v("\n                    Layers are used to structure content on the z index. The higher the layer number \n                    the further forward the component is placed. A component on layer 1 will appear \n                    below a component on layer 2.\n                ")]), _vm._v(" "), _vm._l((Object.keys(this.layers).reverse()), function(layer) {
    return _c('example', {
      key: layer,
      attrs: {
        "var-name": layer
      },
      slot: "examples"
    }, [_c('div', {
      class: layer
    }, [_c('p', {
      staticClass: "layer-text"
    }, [_vm._v(_vm._s(layer))])])])
  })], 2)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2c676132"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vars/layers.vue
// module id = 1450
// module chunks = 1